const lowerBound = 5;
const upperBound = 10;
const dockLowerBound = 1;
const dockUpperBound = 2;

export const SPR_REGEX = new RegExp(
  `^[A-Z0-9]{${lowerBound},${upperBound}}-[A-Z0-9]{${lowerBound},${upperBound}}$`
);
export const SPDR_REGEX = new RegExp(
  `^([A-Z0-9]{${lowerBound},${upperBound}}-){2}([A-Z0-9]{${dockLowerBound},${dockUpperBound}}|-)$`
);

export const PSR_REGEX = new RegExp(
  `^[PS]-[A-Z0-9]{${lowerBound},${upperBound}}-[A-Z0-9]{${lowerBound},${upperBound}}$`
);
export const PDSR_REGEX = new RegExp(
  `^[PS]-[A-Z0-9]{${lowerBound},${upperBound}}-([A-Z0-9]{${dockLowerBound},${dockUpperBound}}|-)-[A-Z0-9]{${lowerBound},${upperBound}}$`
);
